import * as actions from './redux/actions';

import { KuposInput, KuposSteps, PaymentOptions } from '../common';
import React, { Component } from 'react';

import { AppData } from '../../services';
import BookingSuccess from '../pb-payment-details/BookingSuccess';
import CommonService from '../../services/commonService';
import DateService from '../../services/dateService';
import { PaymentSidebarBip } from './PaymentSidebarBip';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

export class BipPayment extends Component {
	static propTypes = {
		home: PropTypes.object.isRequired,
		data: PropTypes.object.isRequired,
		actions: PropTypes.object.isRequired,
		t: PropTypes.func,
	};
	idCardTypes = [];

	paymentGatewayList;

	constructor(props) {
		super(props);
		this.state = {
			stepsMenu: [
				{ label: 'RECHARGE', active: false },
				{ label: 'PAYMENT', active: true },
				{ label: 'CONFIRMATION', active: false },
			],
			stepsMenu2: [
				{ label: 'RECHARGE', active: false },
				{ label: 'PAYMENT', active: false },
				{ label: 'CONFIRMATION', active: true },
			],
			selectedPaymentGateway: null,
			wallet: false,
			walletMoney: 0,
			cardTypes: this.props.home.metaData ? this.props.home.metaData.card_type : null,
			cardChecked: false,
			email: null,
			confirmEmail: null,
			status: 'initial',
			lastRechargeAmount: 0,
		};

		try {
			let metaData;
			if (!this.props.home.metaData) {
				if (!CommonService.getLocal('from-bip-payment')) {
					this.props.history.push(`/`);
				} else {
					localStorage.removeItem('from-bip-payment');
				}
			} else {
				this.home = this.props.home;
				metaData = this.props.home.metaData;
			}
			if (metaData) {
				this.paymentGatewayList = CommonService.copyObject(metaData.payment_gate_way_list_v1);
				for (let c in metaData.id_card_types) {
					this.idCardTypes.push({
						value: metaData.id_card_types[c],
						label: c,
					});
				}
			}
		} catch (e) {
			console.log(e);
			this.props.history.push(`/`);
		}

		//Get one click cards
		this.props.actions.apiCall({ url: AppData.BASE_URL + 'api/my_cards_list', type: 'home' }).then(
			res => this.onOneClickCardsFetch(res),
			err => this.onOneClickCardsFetch(err),
		);

		//get bip card analytics
		this.props.actions
			.apiCall({
				url:
					AppData.BIP_URL + 'api/v1/bipCardAnalytics/' + this.props.data &&
					this.props.data.bipData &&
					this.props.data.bipData.email + '/' + this.props.data &&
					this.props.data.bipData &&
					this.props.data.bipData.cardNumber,
			})
			.then(
				res => this.onBipCardsDetailsFetch(res),
				err => this.onBipCardsDetailsFetch(err),
			);

		// this.getThisCardDetails();
	}

	// getThisCardDetails = () => {
	//   this.props.actions
	//     .apiCall({
	//       url:
	//         AppData.BIP_URL +
	//         'api/v1/bipCardAnalytics/' +
	//         this.props.data.bipData.email +
	//         '/' +
	//         this.props.data.bipData.cardNumber,
	//     })
	//     .then(
	//       res => this.onBipCardsDetailsFetch(res),
	//       err => this.onBipCardsDetailsFetch(err),
	//     );
	// };

	onBipCardsDetailsFetch = result => {
		console.log('Bip card details fetcehd are ', result);
		if (result && result.data && result.data.data) {
			this.setState({ lastRechargeAmount: result.data.data.last_recharge_amount });
		}
	};

	componentDidMount() {
		window.scrollTo(0, 0);

		this.setState({
			email: this.props.data.bipData && this.props.data.bipData.email,
			confirmEmail: this.props.data.bipData && this.props.data.bipData.confirmEmail,
		});

		// console.log('Props in constructorrrrrrr', this.props);

		if (this.props.history.location.pathname.includes('success')) {
			this.setState({ status: 'success', rechargeBipCardStatus: true });
		} else if (this.props.history.location.pathname.includes('failure')) {
			this.setState({ status: 'failure', rechargeBipCardStatus: false });
		}
	}

	onOneClickCardsFetch = result => {
		if (result && result.data && result.data.card_details) {
			this.setState({ myCards: result.data.card_details });
		}

		this.setState({ showPaymentsOptions: true });
		// console.log('onOneClickCardsFetch response ', result);
	};

	renderNotLoggedInBlock = () => {
		return (
			<div className="kupos-card bip-dont-have-account-block  flex-row">
				<div className="no-account-img">
					<img src="/static/images/bip_rect.svg" />
				</div>
				<div>
					<div className="heading bold font13">
						{this.props.t('PASSENGER_DETAILS.REGISTER_AND_RECHARGE')}
					</div>
					<div className="font10 secondary-text bold-text no-account-sub-head">
						{this.props.t('PASSENGER_DETAILS.CREATE_YOURS_AND_GET_BENIFIT')}
					</div>
				</div>
				<div>
					<button
						className="kupos-button font12"
						onClick={() => this.props.actions.openCloseLoginModal(true)}
					>
						<span>{this.props.t('PASSENGER_DETAILS.CREATE_ACCOUNT')}</span>
					</button>
				</div>
			</div>
		);
	};

	onPaymentTypeSelect = paymentItem => {
		console.log('Payment gateway selected ', paymentItem);

		paymentItem
			? this.setState({
				selectedPaymentGateway:
					this.state.selectedPaymentGateway == paymentItem.code ? null : paymentItem.code,
				cardChecked: false,
			})
			: this.setState({
				selectedPaymentGateway: null,
				cardChecked: true,
			});
		// this.setState({
		//   selectedPaymentGateway: paymentItem.code,
		//   cardChecked: false,
		// });
	};

	checkWallet = () => { };

	validate = () => {
		let errorCount = 0;
		if (!this.state.email) {
			this.setState({
				emailError: {
					message: 'Ingresa tu correo electrónico',
				},
			});
			errorCount++;
		}
		if (!this.state.confirmEmail) {
			this.setState({
				confirmEmailError: {
					message: 'Los correos electrónicos deben coincidir',
				},
			});
			errorCount++;
		}
		// if (!this.state.selectedPaymentGateway && !this.state.cardChecked) {
		//   this.refs.toast.show('Select Payment mode!');
		//   errorCount++;
		// }

		if (errorCount > 0) {
			return false;
		} else {
			return true;
		}
	};

	onSubmit = () => {
		if (!this.validate()) {
			return;
		}
		// console.log('All good and props are', this.props);
		// console.log('All good and some data is', this.state.cardChecked, this.state.selectedCard);

		this.setState({ bipRechargePending: true });

		let data;
		CommonService.isLoggedIn(this.props.data.loginData)
			? (data = {
				user_id: this.props.loginData.id,
				user_name: this.props.loginData.name,
				bip_card_number: this.props.data.bipData.cardNumber,
				amount: Number(this.props.data.bipData.amount),
				email: this.state.email,
				confirm: this.state.confirmEmail,
				rechare_date_time: DateService.getUTC(),
				rechare_date: DateService.getTodayString(),
				rechare_time: `${DateService.getCurrentHour()}.${DateService.getCurrentMinute()}`,
				// rechare_time: "10.30",
				is_my_card: this.props.data.bipData.isMyCard == 'adhoc' ? false : true,
				payment_type: 'WEBPAY_ONECLICK',
				remark: 'Adhoc Recharge',
				success_url:
					window.location.protocol + '//' + window.location.host + '/bip-payment/success',
				// success_url: 'https://kupos.cl/en/bip-recharge/success',/
				failure_url:
					window.location.protocol + '//' + window.location.host + '/bip-payment/failure',
				// failure_url: 'https://kupos.cl/en/bip-recharge/failure',
				is_oneclick_regd_user: this.state.cardChecked ? true : false,
				card_category: this.state.cardChecked ? this.state.selectedCard[1] : 0,
				card_number: this.state.cardChecked ? this.state.selectedCard[0].substr(12, 15) : '',
			})
			: (data = {});
		localStorage.setItem('from-bip-payment', 'true');

		console.log('Bip data to pass in air', data);

		CommonService.googleProductCheckout(
			[
				{
					name: data.bip_card_number,
					id: data.bip_card_number,
					price: data.amount,
					brand: 'bip',
					category: 'bip',
				},
			],
			'WEBPAY_ONECLICK',
			null,
			data.bip_card_number,
		);

		this.props.actions
			.apiCall({
				url: AppData.BIP_URL + 'api/v1/bipTransaction',
				method: 'POST',
				data: data,
			})
			.then(
				res => this.onBipCardRechargeResponse(res),
				err => this.onBipCardRechargeResponse(err),
			);
	};

	onBipCardRechargeResponse = result => {
		this.setState({ bipRechargePending: false });
		console.log('onBipCardRechargeResponse------------------', result);

		if (result && result.data && result.data.success && result.data.data) {
			console.log('inside if', result.data.data);

			if (result.data.data.oneclick_html_stg) {
				// this.props.setBookingApiResponse(result.data.data);
				document.write(result.data.data.oneclick_html_stg); //todo
			} else {
				this.setState({
					status: 'success',
					rechargeBipCardModal: true,
					rechargeBipCardStatus: true,
					rechargeBipCardModalBody: 'Bip card recharged successfully!',
				});
				this.props.history.push(`/bip-payment/success`);
			}
		} else {
			this.setState({
				status: 'failure',
				rechargeBipCardModal: true,
				rechargeBipCardStatus: false,
				rechargeBipCardModalBody: 'Some problem in recharging bip card, Please try again!',
			});
			this.props.history.push(`/bip-payment/failure`);
		}
	};

	promoCheckboxChange = () => {
		this.setState({ promoCodeChecked: !this.state.promoCodeChecked });
	};

	promoCodeChange = () => { };

	promoCodeBlur = () => { };

	applyPromoCode = () => { };

	walletMoneyAdded = () => { };

	virtualMoneyAmount = () => { };

	basicFare = () => { };

	calculateNetFare = () => { };
	calculateNetFareUSD = () => { };

	cardChoosen = (val, key) => {
		this.setState({
			selectedCard: val,
			cardChecked: true,
			selectedPaymentGateway: null,
		});
	};

	inputChange = (val, type) => {
		switch (type) {
			case 'email':
				this.setState({ email: val, emailError: null });
				break;
			case 'confirm_email':
				this.setState({ confirmEmail: val, confirmEmailError: null });
				break;
		}
	};

	inputBlur = (val, type) => {
		if (!val) {
			switch (type) {
				case 'email':
					this.setState({ emailError: { message: 'HOME.BIP_EMAIL_ID' } });
					break;
				case 'confirm_email':
					this.setState({ confirmEmailError: { message: 'HOME.BIP_CONFIRM_EMAIL_ID' } });
					break;
			}
		} else {
			console.warn('inside else ');

			if (type == 'email' && !CommonService.isEMailValid(val)) {
				this.setState({ emailError: { message: 'VALIDATIONS.VALID_EMAIL_VALIDATION' } });
			} else if (type == 'confirm_email' && !CommonService.isEMailValid(val)) {
				this.setState({
					confirmEmailError: { message: 'VALIDATIONS.VALID_EMAIL_VALIDATION' },
				});
			} else if (type == 'confirm_email' && this.state.email != val) {
				this.setState({ confirmEmailError: { message: 'VALIDATIONS.VALID_EMAIL_MATCH' } });
			}
		}
	};

	renderBookingConfirmation = () => {
		if (this.state.status == 'success') {
			return (
				<BookingSuccess
					history={this.props.history}
					success={true}
					purchaseType="bip_recharge"
					t={this.props.t}
				/>
			);
		} else if (this.state.status == 'failure') {
			return <BookingSuccess purchaseType="bip_recharge" success={false} />;
		}
	};

	renderPaymentDetails = t => {
		return (
			<div className="pb-service-list-payment-details-page content-container flex-row passenger-and-payment-details-container">
				<div className="passenger-input-container">
					{!CommonService.isLoggedIn() ? this.renderNotLoggedInBlock() : null}

					<div className="kupos-card passenger-input-details">
						<div className="flex-row passenger-details-title-row">
							<div className="font13">
								{this.props.t('PASSENGER_DETAILS.BIP_CLIENT_DETAILS.NORMAL')}
								<span className="bold">
									{this.props.t('PASSENGER_DETAILS.BIP_CLIENT_DETAILS.BOLD')}
								</span>
							</div>
							<div className="primary-text bold-text countdown-counter font13">
								{/* <img src="/static/images/icons/icon-chronometer.png" /> */}
								{/* <span>{this.state.countdown}</span> */}
							</div>
						</div>

						<div className="bip-payment-inputs">
							<div>
								<div className="name-input font10 bold-text">
									{this.props.t('HOME.BIP_EMAIL_ID')}
								</div>
								<KuposInput
									className="kupos-border"
									type="text"
									value={this.state.email}
									placeholder={t('HOME.BIP_EMAIL_ID')}
									onChange={text => this.inputChange(text, 'email')}
									onBlur={text => this.inputBlur(text, 'email')}
									error={this.state.emailError ? true : false}
									errorMessage={this.state.emailError ? t(this.state.emailError.message) : null}
								/>
							</div>

							<div>
								<div className="surname-input font10 bold-text">
									{this.props.t('PASSENGER_DETAILS.EMAIL_CONFIRMATION')}
								</div>
								<KuposInput
									className="kupos-border"
									type="text"
									value={this.state.confirmEmail}
									placeholder={t('PASSENGER_DETAILS.EMAIL_CONFIRMATION')}
									onChange={text => this.inputChange(text, 'confirm_email')}
									onBlur={text => this.inputBlur(text, 'confirm_email')}
									error={this.state.confirmEmailError ? true : false}
									errorMessage={
										this.state.confirmEmailError ? t(this.state.confirmEmailError.message) : null
									}
								/>
							</div>
						</div>
					</div>

					{this.state.showPaymentsOptions ? (
						<PaymentOptions
							paymentGatewayList={this.paymentGatewayList}
							selected={this.state.selectedPaymentGateway}
							onPaymentSelect={this.onPaymentTypeSelect}
							walletChecked={this.state.wallet}
							walletMoney={0}
							// walletMoney={this.props.common.loginData ? this.props.common.loginData.balances.clp.total : ''}
							isLoggedIn={false}
							// isLoggedIn={this.props.common.loginData && this.props.common.loginData.auth_token}
							checkWallet={this.checkWallet}
							onPay={this.onSubmit}
							bookTicketPending={this.state.bipRechargePending}
							bookingError={this.state.bookingError}
							onPromoCheckboxChange={this.promoCheckboxChange}
							promoCodeChecked={this.state.promoCodeChecked}
							onPromoCodeChange={this.promoCodeChange}
							onPromoCodeBlur={this.promoCodeBlur}
							onApplyPromoCode={this.applyPromoCode}
							promoCodeError={
								this.state.promoCodeError ? this.props.t(this.state.promoCodeError.message) : null
							}
							t={this.props.t}
							history={this.props.history}
							tncChecked={this.state.tncChecked ? true : false}
							onTncChange={() => this.setState({ tncChecked: !this.state.tncChecked })}
							myCards={this.state.myCards ? this.state.myCards : null}
							cardTypes={this.state.cardTypes}
							cardChoosen={this.cardChoosen}
							cardChecked={this.state.cardChecked}
						/>
					) : null}
				</div>

				<PaymentSidebarBip
					wallet={this.state.wallet}
					walletMoneyAdded={this.walletMoneyAdded}
					virtualMoneyAmount={this.virtualMoneyAmount}
					basicFare={this.basicFare}
					calculateNetFare={this.calculateNetFare}
					calculateNetFareUSD={this.calculateNetFareUSD}
					promoCode={this.state.promoCode}
					promoCouponAmount={this.state.promoCouponAmount}
					showUsd={this.state.selectedPaymentGateway == 23 ? true : false}
					t={this.props.t}
					bipData={this.props.data.bipData}
					lastRechargeAmount={this.state.lastRechargeAmount}
				/>
			</div>
		);
	};

	render() {
		const { t } = this.props;

		console.log('Card checked ', this.state.cardChecked);
		console.log('PG Checked ', this.state.selectedPaymentGateway);

		return (
			<div className="home-bip-payment">
				<div className="content-container">
					<KuposSteps
						menuButtons={
							this.state.status == 'initial' ? this.state.stepsMenu : this.state.stepsMenu2
						}
						t={this.props.t}
					// onStepClick={this.onStepClick}
					/>
				</div>

				{this.state.status == 'initial'
					? this.renderPaymentDetails(t)
					: this.renderBookingConfirmation()}
			</div>
		);
	}
}

/* istanbul ignore next */
function mapStateToProps(state) {
	return {
		home: state.home,
		data: state.myAccount,
		loginData: state.common.loginData,
	};
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators({ ...actions }, dispatch),
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('common')(BipPayment));



// WEBPACK FOOTER //
// ./src/features/home/BipPayment.js